import { UsersDatasourceInfo } from './usersSlice'
import { gql } from 'graphql-request'

export const queryDataSources = (): string => {
  return gql`
    {
      datasources {
        count
        edges {
          node {
            id
            name
            type
            createdBy
            idp {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryDataSources = (raw: any): UsersDatasourceInfo[] => {
  const datasourcesList = raw.datasources.edges.map((edge) => {
    const ds = edge.node
    return {
      id: ds.id,
      name: ds.name || '',
      type: ds.type || '',
      status: ds.status,
      createdBy: ds.createdBy,
      idpId: ds.idp?.edges?.[0]?.node?.id || ''
    }
  })

  return datasourcesList
}

export const queryUserCountsWidget = (): string => {
  return gql`
    query GetUserCounts {
      totalUsers: accessControlUsers {
        count
      }
      activeUsers: accessControlUsers(accountStatus: ACTIVE) {
        count
      }
      deletedUsers: accessControlUsers(accountStatus: DELETED) {
        count
      }
      disabledUsers: accessControlUsers(accountStatus: DISABLED) {
        count
      }
      externalUsers: accessControlUsers(userType: EXTERNAL) {
        count
      }
      guestUsers: accessControlUsers(userType: GUEST) {
        count
      }
    }
  `
}
export const mapQueryUserCountsWidget = (raw: any) => {
  return {
    totalUsers: raw?.totalUsers?.count || 0,
    activeUsers: raw?.activeUsers?.count || 0,
    deletedUsers: raw?.deletedUsers?.count || 0,
    disabledUsers: raw?.disabledUsers?.count || 0,
    externalUsers: raw?.externalUsers?.count || 0,
    guestUsers: raw?.guestUsers?.count || 0
  }
}
